<template>
  <div class="plug-wrapper">
    <img src="../assets/img/logo-large.png" alt="logo">
    <div class="plug">
      <div class="text-right">
        <img src="../assets/img/plug-arrow.svg" alt="arrow">
      </div>
      <div class="content-block-title text-center mb-3">
        All functional you can use here
      </div>
      <p class="text-muted text-center mb-1">For quick access, please add our extension to browser panel</p>
      <img src="../assets/img/plug-ext.png" alt="ext">
    </div>
  </div>
</template>

<script>

export default {
  name: 'FreeVersionDesktopPlug',
}
</script>

<style lang="scss">
.plug {
  position: absolute;
  right: 0;
  top: 0;
  border: 1px dashed #C0C0C0;
  padding: 20px 50px 50px;
  width: 360px;
  background: #FBF5F2;

  &-wrapper {
    position: relative;
    background: #FBF5F2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
}
</style>
